import { type MembershipFragmentType } from "clientState/operations/fragments/userFragment/contract";

import { LOGIN_METHODS } from "../useRememberMe";
import { type BuildUserType, type GetUserStatusType } from "./contract";
import { MEMBERSHIP_STATUS } from "./membershipStatus";

export const USER_STATUS = {
  logged: "LOGGED",
  notLogged: "NOT_LOGGED",
  remembered: "REMEMBERED",
  loading: "LOADING",
} as const;
export const REQUEST_STATUS = {
  loading: "loading",
  error: "error",
  success: "success",
  idle: "idle",
} as const;

// TODO(DPT-2134): REMOVE REMEMBERED USER AND ALL RELATED CONDITIONS

const getUserStatus: GetUserStatusType = ({
  loading,
  recognizedUserState,
  rememberedUser,
  user,
}) => {
  const recognizedUserLoading =
    recognizedUserState !== undefined && recognizedUserState?.loading;

  if (loading || recognizedUserLoading) return USER_STATUS.loading;
  if (user) return USER_STATUS.logged;

  const isUserRememberedOrRecognized =
    !!rememberedUser?.email || !!recognizedUserState?.user?.email;

  if (isUserRememberedOrRecognized) return USER_STATUS.remembered;
  return USER_STATUS.notLogged;
};

const buildUser: BuildUserType = ({
  loading,
  recognizedUserState,
  rememberedUser,
  user,
}) => {
  const userStatus = getUserStatus({
    loading,
    recognizedUserState,
    rememberedUser,
    user,
  });

  const displayName =
    user?.displayName ??
    recognizedUserState?.user?.displayName ??
    rememberedUser?.displayName;

  const email =
    user?.email ?? recognizedUserState?.user?.email ?? rememberedUser?.email;

  const recognizedUserMembership =
    typeof recognizedUserState?.user?.isPrime === "boolean"
      ? ({
          status: recognizedUserState?.user?.isPrime
            ? MEMBERSHIP_STATUS.activated
            : MEMBERSHIP_STATUS.deactivated,

          name: displayName,
          lastNames: "",
        } as MembershipFragmentType)
      : undefined;

  let membership = user?.membership;
  if (!user) {
    membership = rememberedUser?.membership ?? recognizedUserMembership;
  }

  const rememberedUserHasRecognitionLoginType =
    rememberedUser?.loginType === LOGIN_METHODS.recognition;

  const needsUserRecognitionAuthorizationFromRecognitionModule =
    recognizedUserState?.needsUserRecognitionAuthorization ?? false;

  // user recognition is only needed when the user is remembered with recognition login type or the user is not logged,
  const needsUserRecognitionAuthorization =
    user === null &&
    rememberedUserHasRecognitionLoginType &&
    needsUserRecognitionAuthorizationFromRecognitionModule;

  return {
    id: user?.id,
    name: user?.membership?.name,
    lastNames: user?.membership?.lastNames,
    membershipPartner: user?.membership?.partner,
    displayName,
    email,
    membership,
    accountType: rememberedUser?.accountType,
    status: userStatus,
    needsUserRecognitionAuthorization,
  };
};

export default buildUser;
